
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { postAddVersion, updateVersion, existsVersion } from '@/api/version';
import { eAuditStatus, eUpdateType, eUpdateVersion, iVersion } from '@/interface/version';
import UpdateContent from './update-content.vue';
@Component({
  components: { UpdateContent },
})
export default class EditVersion extends Vue {
  @Prop() visible!: Boolean;
  @Prop() flag?: Number;
  @Prop() model!: iVersion;
  @Prop() exitTitle!: string;
  andriod: eUpdateVersion = eUpdateVersion.ANDRIOD;
  auditClose: eAuditStatus = eAuditStatus.CLOSE;
  auditOpen: eAuditStatus = eAuditStatus.OPEN;
  newMode: any = [];
  isFocusTrue: boolean = false;
  errorMsg: string = '';
  reg = /^[0-9]+\.[0-9]+\.[0-9]+$/;
  rules = {
    version: [{ required: true, validator: this.validateVersion, trigger: 'blur' }],
    change_log: [{ require: true, trigger: 'blur', validator: this.validateChangeLog }],
  };
  validateChangeLog(rule: any, value: any, callback: any) {
    const obj = this.newMode.change_log;
    let len = 0;
    for (let i = 0; i < obj.length; i++) {
      const value = obj[i].trim();
      len += value.length;

      if (value == '') {
        return callback(new Error('请输入内容第' + (i + 1) + '行内容'));
      } else if (len > 150) {
        return callback(new Error('更新内容不能大于150字'));
      } else {
        if (i == obj.length - 1) {
          return callback();
        }
      }
    }
  }
  validateVersion(rule: any, value: any, callback: any) {
    // const reg = /^\d.\d.\d/;

    this.errorMsg = '';
    if (this.reg.test(value)) {
      return callback();
    } else {
      this.errorMsg = '版本号请输入：列(1.2.3)';
      return callback(new Error('版本号请输入：列(1.2.3)'));
    }
  }
  AddText() {
    this.newMode.change_log.push('');
  }
  deleteText(index: number) {
    this.newMode.change_log.splice(index, 1);
  }
  changeValue(index: number, value: string) {
    this.newMode.change_log[index] = value;
  }
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isFocusTrue = false;
        this.saveVersion();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  @Emit()
  close() {}

  async saveVersion() {
    this.$msgbox({
      title: '提示',
      message: this.newMode.id <= 0 ? '确定添加?' : '确定修改?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          if (this.newMode.id > 0) {
            await updateVersion(this.newMode);
          } else {
            await postAddVersion(this.newMode);
          }
          instance.confirmButtonLoading = false;
          done();
          setTimeout(() => {
            this.$emit('close');
          }, 200);
        } else if (action === 'cancel') {
          instance.confirmButtonLoading = false;
          done();
        }
      },
    })
      .then(() => {
        // done();
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
  mounted() {
    this.newMode = this.model;
    if (this.newMode.id <= 0) {
      this.newMode.change_log = ['', ''];
    }
  }
}
